import { Injectable } from '@angular/core';
import { ApiService } from 'core/api/api.service';
import { forkJoin } from 'rxjs';
import { LastQuotesFilters } from 'src/app/modules/marketing/products/entities/last-quotes-filters.class';

@Injectable({
  providedIn: 'root'
})
export class QuotesService {
  getQuotesUrl = '/api/quote/catalog/list';

  constructor(
    private apiService: ApiService,
  ) { }

  /**
   * Gets last quotes, if there are filter values, 10 exact search quotes and 10 partial search quotes are retrieved
   * @param filterValues filters
   * @param amEmployeeId account manager employee id
   * @param customerId customer id
   * @param pageOffset page offset for pagination
   * @returns an array of QuoteListResponse with exact and partial results or QuoteListResponse no filterValues
   */
  getLastQuotes(
    filterValues: LastQuotesFilters, amEmployeeId?: string, customerId?: string, pageOffset?: number
  ) {
    const payloadExactSearch = this.createLastQuotesPayload(filterValues, false, amEmployeeId, customerId, pageOffset);
    const payloadPartialSearch = this.createLastQuotesPayload(filterValues, true, amEmployeeId, customerId, pageOffset);
    if (filterValues) {
      return forkJoin([
        this.apiService.post(this.getQuotesUrl, payloadExactSearch), this.apiService.post(this.getQuotesUrl, payloadPartialSearch)]);
    } else {
      return this.apiService.post(this.getQuotesUrl, payloadExactSearch);
    }
  }

  /**
   * Creates the payload for last ten open quotes
   * @param filterValues filters
   * @param partialSearch partial search flag
   * @param amEmployeeId account manager employee id
   * @param customerId customer id
   * @param pageOffset page offset for pagination
   * @returns the payload
   */
  createLastQuotesPayload(filterValues: LastQuotesFilters, partialSearch: boolean, amEmployeeId?: string, customerId?: string,
    pageOffset?: number) {
    const payload = {
      employeeId: amEmployeeId,
      customerId,
      date: {
        startDate: filterValues?.startDate || null,
        endDate: filterValues?.endDate || null
      },
      nameFilter: {
        employeeId: amEmployeeId,
        partialSearch
      },
      showAllQuotes: customerId ? false : undefined,
      offset: pageOffset,
    };

    if (filterValues) {
      payload.nameFilter = {
        employeeId: amEmployeeId,
        bpNumber: filterValues.bpNumber || undefined,
        customerName: filterValues.customerName || undefined,
        quoteNumber: filterValues.quoteNumber || undefined,
        quoteName: filterValues.quoteName || undefined,
        dollarAmount: filterValues.dollarAmount || undefined,
        confidenceToClosePercentageId: filterValues.confidence?.toString() || undefined,
        dollarRangeLow: filterValues.dollarRangeMin || undefined,
        dollarRangeHigh: filterValues.dollarRangeMax || undefined,
        expiringInDays: filterValues.expiringInDays || undefined,
        partialSearch
      } as any;
    }
    return payload;
  }
}

